import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HintListDirective, HintListerDirective } from './hint-list.directive';
import { HintListComponent } from './hint-list/hint-list.component';
import { HintComponent } from './hint.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [
    HintComponent,
    HintListComponent,
    HintListDirective,
    HintListerDirective
  ],
  declarations: [
    HintComponent,
    HintListComponent,
    HintListDirective,
    HintListerDirective
  ],
  providers: []
})
export class HintModule {}
